module.exports = __webpack_public_path__ + "img/Kc.ec7d7f5f.png";